@let t = text();

<div class="week-strip" [class.week-strip--compact]="compact()">
  <div class="week-strip__toolbar">
    <button type="button" class="week-strip__nav" (click)="shiftWeek(-1)"
            [attr.aria-label]="t.previousWeek" [title]="t.previousWeek" data-test-id="week-strip-previous">
      <i class="fas fa-chevron-left" aria-hidden="true"></i>
    </button>
    <button type="button" class="week-strip__nav week-strip__nav--today" (click)="goToToday()"
            data-test-id="week-strip-today">
      {{ t.today }}
    </button>
    <button type="button" class="week-strip__nav" (click)="shiftWeek(1)"
            [attr.aria-label]="t.nextWeek" [title]="t.nextWeek" data-test-id="week-strip-next">
      <i class="fas fa-chevron-right" aria-hidden="true"></i>
    </button>
    <!-- Naar het nu-moment zelf (de nu-lijn), niet enkel naar de dagstart: met
         de maan aan staat de nu-lijn vaak ver onder het begin van vandaag. -->
    <button type="button" class="week-strip__nav week-strip__nav--now" (click)="nowSelected.emit()"
            [attr.aria-label]="t.nowTooltip" [title]="t.nowTooltip" data-test-id="week-strip-now">
      <i class="fas fa-location-crosshairs" aria-hidden="true"></i>
      @if (!compact()) {
        <span class="week-strip__now-label">{{ t.now }}</span>
      }
    </button>
    <span class="week-strip__month">{{ monthLabel() }}</span>
    <!-- Rechts: extra bediening van de host (bv. de poortinfo-schakelaar in de
         smalle weergave) en de kalenderknop. -->
    <span class="week-strip__end">
      <ng-content select="[weekStripEnd]" />
      @if (calendarToggle()) {
        <button type="button" class="week-strip__nav week-strip__calendar-toggle"
                [class.is-active]="calendarOpen()"
                [attr.aria-pressed]="calendarOpen()"
                [attr.aria-label]="calendarOpen() ? t.hideCalendar : t.showCalendar"
                [title]="calendarOpen() ? t.hideCalendar : t.showCalendar"
                (click)="calendarToggled.emit()" data-test-id="week-strip-calendar-toggle">
          <i class="fas fa-calendar-days" aria-hidden="true"></i>
        </button>
      }
    </span>
  </div>

  <div class="week-strip__days" role="tablist">
    @for (day of days(); track day.key) {
      <button type="button" role="tab" class="week-strip__day"
              [class.is-today]="day.isToday"
              [class.is-focus]="day.isFocus"
              [attr.aria-selected]="day.isFocus"
              (click)="daySelected.emit(day.key)"
              [attr.data-test-id]="'week-strip-day-' + day.key">
        <span class="week-strip__weekday">{{ day.weekday }}</span>
        <span class="week-strip__number">{{ day.dayNumber }}</span>
        @if (day.sunLine; as sunLine) {
          <hd-transit-sun-line class="week-strip__sun-line" [day]="sunLine" />
        }
      </button>
    }
  </div>
</div>
